module.exports = __webpack_public_path__ + "img/completed-animated.106dccdf.svg";